<template>
  <router-view></router-view>
</template>

<script>
import { getUserToken } from "@/storage/memoryStorage";

export default {

  computed: {
    isConnected() {
      return this.$store.getters.isConnected;
    }
  },

  watch: {
    isConnected: function(newStatus, oldStatus) {
      if (newStatus) {
        this.statesSubscribe(true);
      }
    }
  },

  methods: {
    statesSubscribe: function(subscribe) {
      const stateSubscribe = {
        userToken: getUserToken(),
        state: subscribe
      };
      this.$socket.send(JSON.stringify(stateSubscribe));
    },
  },

  mounted() {
    if (this.isConnected) {
      this.statesSubscribe(true);
    }
  },

  beforeDestroy() {
    try {
      this.statesSubscribe(false);
    } catch (err) {
      //console.log("Unable send unsubscribe from live data");
    }
  }

};
</script>
